import { render, staticRenderFns } from "./customizeSportsOrderPanel.vue?vue&type=template&id=03be01bf&lang=pug&"
import script from "./customizeSportsOrderPanel.vue?vue&type=script&lang=js&"
export * from "./customizeSportsOrderPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports